/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FollowupModeDto = {
    /**
     * Session mode
     */
    mode: FollowupModeDto.mode;
    /**
     * Per-session price for this mode
     */
    price: string;
};
export namespace FollowupModeDto {
    /**
     * Session mode
     */
    export enum mode {
        ONLINE = 'online',
        CLIENT_LOCATION = 'client_location',
        EXPERT_LOCATION = 'expert_location',
    }
}

